export const Ads = {
  'div-gpt-ad-7513743-1': {
    sizes: [ [ 320, 50 ], 'fluid' ],
    mapping: {
      0: [ 320, 50 ]
    },
    slot: '/302423036/vodacom_connectu/homepage/middle_leaderboard'
  },
  'div-gpt-ad-7513743-2': {
    sizes: [ [ 300, 600 ], 'fluid' ],
    mapping: {
      0: [ 300, 600 ]
    },
    slot: '/302423036/vodacom_connectu/homepage/news_carousel_mpu'
  },
  'div-gpt-ad-7513743-3': {
    sizes: [ [ 320, 50 ], 'fluid' ],
    mapping: {
      0: [ 320, 50 ]
    },
    slot: '/302423036/vodacom_connectu/homepage/bottom_leaderboard'
  },
  'div-gpt-ad-3754209-1': {
    sizes: [ [ 320, 50 ], 'fluid' ],
    mapping: {
      0: [ 320, 50 ]
    },
    slot: '/302423036/vodacom_connectu/in_article_summary/top_leaderboard'
  }
};

export const AdNames = {
  MiddleLeaderboard: 'div-gpt-ad-7513743-1',
  NewsCarousel: 'div-gpt-ad-7513743-2',
  BottomLeaderboard: 'div-gpt-ad-7513743-3',
  TopLeaderboard: 'div-gpt-ad-3754209-1'
};
